module.exports = __webpack_public_path__ + "img/A7404528.926bad2d.jpg";